export const build = { date:"2026-03-18.1240", stage:"alpha" }
